
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { FaCamera, FaFile, FaVideo } from 'react-icons/fa';
import { InputContainer } from '../form/form.module';
import { InputLabelContainer } from '../form/label/containers/input-label.container';

export const MediaInfoComponent = ({ changeImage, mediaFiles, fileTypes, onFormItemChange, handleOpen, deleteSelectedProduct, handleClose, openConfirmation }: any) => {

  return (
    <>
    {_.map(
              mediaFiles,
              (selectedMedia: any, index: any) => (
                <div className=' py-4'>

<div className=' shadow-card box-border p-4 border-2 rounded-lg '>
     
             
              <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                      label="File Type"
                      labelField="Text"
                      list={fileTypes}
                      onValueChange={(event: any, newValue: any) => {
                        onFormItemChange({
                          value: event.target.value,
                          field: 'FileTypeId',
                          idx: index
                        });
                      } }
                      type="select"
                      value={selectedMedia?.FileTypeId}
                      valueField="Value" />
                  {selectedMedia.FileTypeId === 10 &&
                    <div  onClick={() => changeImage(
                      index,
                      'FileMappingURL',
                      'image'
                    )}> 
                       <InputLabelContainer label="Pictures"/>
                      {selectedMedia?.FileMappingURL && <img

                        src={selectedMedia?.FileMappingURL}
                        className="w-12 h-12" />
}
                      
                        <FaCamera  className=' text-2xl text-skin-ouprimary'/>
                   </div>
}
                  {selectedMedia.FileTypeId === 30 &&

<div  onClick={() => changeImage(
  index,
  'FileMappingURL',
  'video'
)}> 
   <InputLabelContainer label="Videos"/>
  {selectedMedia?.FileMappingURL && <video

    src={selectedMedia?.FileMappingURL}
    className="w-12 h-12" />
}
  
    <FaVideo className=' text-2xl text-skin-ouprimary'/>
</div>
}
                      
                  {selectedMedia.FileTypeId === 20 &&
                    
                      <div onClick={() => changeImage(
                        index,
                        'FileMappingURL',
                        'document'
                      )}><label className="text-[#4E6796] text-xs font-medium mb-2 block">Documents</label><strong>{selectedMedia?.FileMappingURL}</strong>
                     
                     <FaFile className=' text-2xl text-skin-ouprimary'/>
                         </div>

                   }

                  {/* {selectedMedia.Id
                    ? <div className={classes.deleteContainer}>
                      <Button
                        className={classes.delete}
                        color="secondary"
                        onClick={handleOpen}
                        variant="text"
                      >
                        <Delete />
                      </Button>
                      <Modal
                        aria-describedby="simple-modal-description"
                        aria-labelledby="simple-modal-title"
                        onClose={handleClose}
                        open={openConfirmation}
                      >
                        <DeleteConfirmationComponent
                          onClose={handleClose}
                          onSubmit={() => deleteSelectedProduct(
                            selectedMedia,
                            index
                          )} />
                      </Modal>
                    </div>
                    : <></>} */}
              </div>
                </div>
            
                </div>
      )
      )}
    </>
  )
}
export default MediaInfoComponent;
